import React from 'react'
import { useTranslation } from 'react-i18next'
import { AdvantageTranslation, TreatmentUpsellDetails } from '@customTypes/TreatmentUpsellDetails'
import Tooth from '@components/icons/Tooth'
import useStyles from './styles'
import { useTheme } from '@mui/material'

interface AdvantagesProps {
  advantageTranslationKeys: TreatmentUpsellDetails['advantageTranslationKeys']
  disclaimerTranslationKey: TreatmentUpsellDetails['disclaimerTranslationKey']
  advantageHeadlineTranslationKey: TreatmentUpsellDetails['advantageHeadlineTranslationKey']
}

export const Advantages = ({
  advantageTranslationKeys,
  disclaimerTranslationKey,
  advantageHeadlineTranslationKey,
}: AdvantagesProps) => {
  const classes = useStyles()
  const theme = useTheme()
  const { t } = useTranslation()

  const Advantage = ({ advantage }: { advantage: AdvantageTranslation }) => {
    const translationExist = t(advantage.second) && t(advantage.second) !== advantage.second

    return translationExist ? (
      <div className={classes.advantage}>
        <Tooth sx={{ fill: theme.palette.primary[200] }} />
        <div className={classes.advantageText}>{t(advantage.second)}</div>
      </div>
    ) : null
  }

  return (
    <div className={classes.advantageContainer}>
      <div className={classes.advantageHeadline}>{t(advantageHeadlineTranslationKey)}</div>

      {advantageTranslationKeys.map((advantage) => (
        <Advantage advantage={advantage} key={advantage.second} />
      ))}
      <div className={classes.divider} />
      <div className={classes.disclaimerText}>{t(disclaimerTranslationKey)}</div>
    </div>
  )
}
